module.exports = __webpack_public_path__ + "media/images/payment_cards/credit_cards/mastercard-6c261aee543130cb4da21f6402bc8c5f.png";